export default __webpack_public_path__ + "static/media/X_wdt_c_cap_1.4e991777.mp3";